import Axios from 'axios';
import { HTTP_STATUS } from '@/constants/common';
import { ApiError, ApiRequestCanceledError, ApiConnectionError, ApiUnknownError, ApiSophonMfaRequiredError, ApiSophonSessionExpiredError } from '@/errors';

export function transformAxiosError (error: unknown): ApiError {
  if (Axios.isCancel(error)) {
    return new ApiRequestCanceledError();
  }

  if (!Axios.isAxiosError(error)) {
    return new ApiUnknownError(
      undefined,
      undefined,
      error instanceof Error ? error : new Error(String(error)),
    );
  }

  if (!error.response) {
    return new ApiConnectionError(undefined, undefined, error);
  }

  const statusCode = error.response.status;

  const responseError = (error.response.data as { error?: { code?: string; message?: string } })
    ?.error;
  const errorCode = responseError?.code;
  const errorMessage = responseError?.message;

  if (error.response.headers['x-sophon-error'] === 'MFA_REQUIRED') {
    return new ApiSophonMfaRequiredError(statusCode, errorCode, error, errorMessage);
  }

  // sophon は MFA_REQUIRED を 403 でも返すため、セッション失効扱いは 401 に限定する
  if (statusCode === HTTP_STATUS.STATUS_CODE.UNAUTHORIZED && error.response.headers['x-sophon-error']) {
    return new ApiSophonSessionExpiredError(statusCode, errorCode, error, errorMessage);
  }

  return new ApiError(statusCode, errorCode, error, errorMessage);
}
